import { createContext, type Dispatch, type SetStateAction } from 'react';

export interface AppBreadcrumbContextValue {
  readonly templateLabel: string | null;
  readonly setTemplateLabel: Dispatch<SetStateAction<string | null>>;
}

export const AppBreadcrumbCtx = createContext<AppBreadcrumbContextValue | null>(null);